import React from "react";
import "../../../AllComponentCSS.css";

const CSS_Lists = () => {
  return (
    <div className="tutorial-container">
      <h1 className="tutorial-title">📋 CSS Lists</h1>

      <p className="tutorial-intro">
        Lists are a great way to group related pieces of information together in
        a structured format. In HTML, lists are created using{" "}
        <code>&lt;ul&gt;</code> (unordered lists), <code>&lt;ol&gt;</code>{" "}
        (ordered lists), and <code>&lt;li&gt;</code> (list items).
      </p>

      <div
        style={{
          background: "linear-gradient(135deg, #d1fae5, #bbf7d0)",
          padding: "1rem",
          borderRadius: "12px",
          marginBottom: "2rem",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#166534", marginBottom: "0.5rem" }}>
          ✨ Why Style Lists with CSS?
        </h2>
        <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
          By default, lists only show simple bullets or numbers. With CSS, you
          can customize list markers, colors, spacing, and even replace markers
          with images or icons to make lists visually engaging.
        </p>
      </div>

      <div className="tutorial-section">
        <h2 className="section-title">🔹 Types of Lists in CSS</h2>
        <ul className="tutorial-list">
          <li>
            <strong>Unordered Lists (ul):</strong> Display items with bullets
            (•) by default.
          </li>
          <li>
            <strong>Ordered Lists (ol):</strong> Display items with numbers (1,
            2, 3...) by default.
          </li>
          <li>
            <strong>Definition Lists (dl):</strong> Consist of terms and their
            descriptions.
          </li>
        </ul>
      </div>

      <div className="tutorial-section">
        <h2 className="section-title">🚀 Next Steps</h2>
        <p>
          In the next lessons, we’ll explore how to style{" "}
          <a href="/css/unordered-list" className="learn-more">
            unordered lists
          </a>{" "}
          and{" "}
          <a href="/css/ordered-list" className="learn-more">
            ordered lists
          </a>{" "}
          with CSS.
        </p>
      </div>
    </div>
  );
};

export default CSS_Lists;
